<template>
	<div />
</template>

<script>
export default {
	name: 'DummyPage',
};
</script>
